import type { AxiosInstance } from 'axios';
import { showApiErrorToastIfNeeded } from '../config/Helper';

export const attachApiErrorToastInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => {
      showApiErrorToastIfNeeded(response?.data);
      return response;
    },
    (error) => {
      showApiErrorToastIfNeeded(error?.response?.data);
      return Promise.reject(error);
    },
  );
};
